import { Loader } from "@googlemaps/js-api-loader"

class GoogleMapsService {
  constructor() {
    this.loader = new Loader({
      apiKey: process.env.VUE_APP_API_GOOGLE_KEY,
      version: "weekly",
      libraries: ["places", "marker", "geometry"] // Pre-load commonly used libraries
    })
    this.isLoaded = false
    this.loadPromise = null
  }

  /**
   * Load Google Maps API if not already loaded
   * @returns {Promise} Promise that resolves when Google Maps is loaded
   */
  async load() {
    if (this.isLoaded) {
      return Promise.resolve()
    }

    if (this.loadPromise) {
      return this.loadPromise
    }

    this.loadPromise = this.loader.load().then(() => {
      this.isLoaded = true
      console.log('Google Maps API loaded successfully')
      return window.google
    }).catch((error) => {
      console.error('Error loading Google Maps API:', error)
      this.loadPromise = null
      throw error
    })

    return this.loadPromise
  }

  /**
   * Import a specific Google Maps library
   * @param {string} library - Library name (e.g., 'places', 'marker', 'geometry')
   * @returns {Promise} Promise that resolves with the library
   */
  async importLibrary(library) {
    await this.load()
    return this.loader.importLibrary(library)
  }

  /**
   * Get the Google Maps API object
   * @returns {Promise} Promise that resolves with google maps object
   */
  async getGoogleMaps() {
    await this.load()
    return window.google
  }

  /**
   * Check if Google Maps API is loaded
   * @returns {boolean} True if loaded, false otherwise
   */
  isApiLoaded() {
    return this.isLoaded && window.google
  }
}

// Export a singleton instance
export default new GoogleMapsService()
